import {flags} from 'libs/rollout';
import {logWithSentry} from 'libs/sentry/sentry';

type OneSignalAnalyticsType = Record<string, string | number>;

/**
 * Check status of OneSignal
 */
export const isOneSignalEnabled = (): boolean => flags.oneSignal.isEnabled();

/**
 * Reset cart status in OneSignal
 */
export const resetOneSignalCartData = () => {
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async function addUserTags(oneSignal) {
        const eventData: OneSignalAnalyticsType = {
            cart_update: '',
            product_image: '',
            product_name: '',
        };
        await oneSignal.User.addTags(eventData);
    });
};

/**
 * Push purchase data to OneSignal
 * @param {OneSignalAnalyticsType} data - data for OneSignal
 */
export const sendOneSignalPurchaseData = (data: OneSignalAnalyticsType) => {
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async function addUserTags(oneSignal) {
        try {
            await oneSignal.User.addTags(data);
            await oneSignal.Session.sendOutcome('PurchaseMade', Number(data.orderprice) || 0);
        } catch (error) {
            logWithSentry(error, 'Error in OneSignal analytics:');
        }
    });
};
